/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdgangAccessControl } from './AdgangAccessControl';
import {
    AdgangAccessControlFromJSON,
    AdgangAccessControlFromJSONTyped,
    AdgangAccessControlToJSON,
    AdgangAccessControlToJSONTyped,
} from './AdgangAccessControl';

/**
 * 
 * @export
 * @interface PermissionConsumptionResponse
 */
export interface PermissionConsumptionResponse {
    /**
     * 
     * @type {any}
     * @memberof PermissionConsumptionResponse
     */
    permissionId?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionConsumptionResponse
     */
    isConsumedByOtherEntitities?: boolean;
    /**
     * 
     * @type {any}
     * @memberof PermissionConsumptionResponse
     */
    numRolePermissions?: any | null;
    /**
     * 
     * @type {any}
     * @memberof PermissionConsumptionResponse
     */
    numUserPermissions?: any | null;
    /**
     * 
     * @type {any}
     * @memberof PermissionConsumptionResponse
     */
    numAdGroupPermissions?: any | null;
    /**
     * 
     * @type {any}
     * @memberof PermissionConsumptionResponse
     */
    numSectionPermissions?: any | null;
    /**
     * 
     * @type {any}
     * @memberof PermissionConsumptionResponse
     */
    numActiveAccessRequests?: any | null;
    /**
     * 
     * @type {Array<AdgangAccessControl>}
     * @memberof PermissionConsumptionResponse
     */
    accessControls?: Array<AdgangAccessControl> | null;
}

/**
 * Check if a given object implements the PermissionConsumptionResponse interface.
 */
export function instanceOfPermissionConsumptionResponse(value: object): value is PermissionConsumptionResponse {
    return true;
}

export function PermissionConsumptionResponseFromJSON(json: any): PermissionConsumptionResponse {
    return PermissionConsumptionResponseFromJSONTyped(json, false);
}

export function PermissionConsumptionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionConsumptionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'permissionId': json['permissionId'] === undefined ? undefined : json['permissionId'] === null ? null : json['permissionId'],
        'isConsumedByOtherEntitities': json['isConsumedByOtherEntitities'] == null ? undefined : json['isConsumedByOtherEntitities'],
        'numRolePermissions': json['numRolePermissions'] === undefined ? undefined : json['numRolePermissions'] === null ? null : json['numRolePermissions'],
        'numUserPermissions': json['numUserPermissions'] === undefined ? undefined : json['numUserPermissions'] === null ? null : json['numUserPermissions'],
        'numAdGroupPermissions': json['numAdGroupPermissions'] === undefined ? undefined : json['numAdGroupPermissions'] === null ? null : json['numAdGroupPermissions'],
        'numSectionPermissions': json['numSectionPermissions'] === undefined ? undefined : json['numSectionPermissions'] === null ? null : json['numSectionPermissions'],
        'numActiveAccessRequests': json['numActiveAccessRequests'] === undefined ? undefined : json['numActiveAccessRequests'] === null ? null : json['numActiveAccessRequests'],
        'accessControls': json['accessControls'] === undefined ? undefined : json['accessControls'] === null ? null : ((json['accessControls'] as Array<any>).map(AdgangAccessControlFromJSON)),
    };
}

export function PermissionConsumptionResponseToJSON(json: any): PermissionConsumptionResponse {
    return PermissionConsumptionResponseToJSONTyped(json, false);
}

export function PermissionConsumptionResponseToJSONTyped(value?: PermissionConsumptionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'permissionId': value['permissionId'],
        'isConsumedByOtherEntitities': value['isConsumedByOtherEntitities'],
        'numRolePermissions': value['numRolePermissions'],
        'numUserPermissions': value['numUserPermissions'],
        'numAdGroupPermissions': value['numAdGroupPermissions'],
        'numSectionPermissions': value['numSectionPermissions'],
        'numActiveAccessRequests': value['numActiveAccessRequests'],
        'accessControls': value['accessControls'] == null ? undefined : ((value['accessControls'] as Array<any>).map(AdgangAccessControlToJSON)),
    };
}

